import React, { useEffect } from "react";
import { Typography, Grid, Paper, } from "@material-ui/core";
import PasswordSettingForm from '../component/portal/passwordsetting/PasswordSettingForm'
import { getUserInfo, typeUserInfo } from '../api/helpline/user'
import { changePassword } from "../api/helpline/account";
import { useGlobalState } from "../provider/Provider";

interface Prop {
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleClickHome: () => void,
  handleError: (err: any) => void,
}

const PasswordSetting: React.FC<Prop> = (props) => {
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  const { handleNotificationOpen, handleClickHome, handleError } = props
  const [userInfo, setUserInfo] = React.useState<typeUserInfo | undefined>()
  const [errmsg, setErrmsg] = React.useState<string>('')
  const [passwordc, setPasswordc] = React.useState<boolean>(false)
  //初期表示APIコール
  useEffect(() => {
    if (userId && token && role) {
      getUserInfo(userId, userId, token, role).then(res => setUserInfo(res)).catch(err => handleError(err))
    }
  }, [globalState])

  const [form, setForm] = React.useState({
    currentpassword: '',
    changepassword: '',
    checkpassword: '',
  })
  const [loading, setLoading] = React.useState<boolean>(false)

  const passwordCheck = (password: string) => {
    let result = password.match(/^[A-Za-z0-9]{8,}$/)
    if (!result) {
      setPasswordc(true)
    } else {
      setPasswordc(false)
    }
  }

  //文字数カット
  const MAX_LENGTH_Password = 128
  const checkCutLength = (str: string): string => {
    if (str.length > MAX_LENGTH_Password) {
      return str.substr(0, MAX_LENGTH_Password)
    } else {
      return str
    }
  }

  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    setForm({
      ...form,
      [event.target.name as string]: checkCutLength(event.target.value as string)
    })
    if (event.target.name === 'changepassword') {
      passwordCheck(event.target.value as string)
    }
  }
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [show, setShow] = React.useState({
    current: false,
    change: false,
    check: false,
  })
  const handleClickCurrentPassword = () => {
    setShow({ ...show, current: !show.current });
  };
  const handleClickChangePassword = () => {
    setShow({ ...show, change: !show.change });
  };
  const handleClickCheckPassword = () => {
    setShow({ ...show, check: !show.check });
  };
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const onSubmit = () => {
    setLoading(true)
    setErrmsg('')
    changePassword(userId, token, role, form.changepassword, form.currentpassword).then(res => {
      if (res.error) {
        setErrmsg(res.error.message)
      } else {
        handleNotificationOpen('success', 'パスワード変更')
        handleClickHome()
      }
      handleClose()
      setLoading(false)
    }).catch(err => { handleClose(); setLoading(false); handleError(err) })
  }
  return (
    <React.Fragment>
      <Typography variant="h6">
        パスワード設定
      </Typography>
      {userInfo && (
        <Grid container spacing={2} justify="center" >
          <Grid item xs={11}>
            <Paper>
              <PasswordSettingForm
                userInfo={userInfo} form={form} show={show} open={open} errmsg={errmsg} loading={loading} passwordc={passwordc} handleClickOpen={handleClickOpen} handleClose={handleClose} onSubmit={onSubmit} handleChangeForm={handleChangeForm} handleClickCurrentPassword={handleClickCurrentPassword} handleClickChangePassword={handleClickChangePassword} handleClickCheckPassword={handleClickCheckPassword} handleMouseDownPassword={handleMouseDownPassword}
              />
            </Paper>
          </Grid>
        </Grid>
      )}
    </React.Fragment>
  )
}

export default PasswordSetting